import { boot } from 'quasar/wrappers';
import "@fontsource/poppins";
import "@fontsource/crimson-pro";
import "@fontsource/open-sans";
import { createPinia } from 'pinia';
import { App } from '@capacitor/app';

export default boot(async ({ app, router }) =>
{
    app.use(createPinia());

    App.addListener('appUrlOpen', function (event)
    {
        try
        {
            const slug = event.url.split('.app').pop();
            if (slug)
            {
                const path = (slug || "").replace("https://realfren.com", "");
                if (path) router.push(path);
            }
        } catch (err)
        {
            console.error(err);
        }
    });
});
